import React from "react"
import { motion } from "framer-motion"
import LandingNav from "./LandingNav"
import LandingFooter from "./LandingFooter"
import LandingNewsSection from "./LandingNewsSection"

const NewsPage: React.FC = () => {
  return (
    <div className="bg-base-100">
      <LandingNav />

      <section className="relative flex min-h-[36vh] items-end overflow-hidden bg-[#0a0a12] pb-10 pt-24 md:min-h-[40vh] md:pb-12 md:pt-28">
        <div className="absolute inset-0 bg-gradient-to-b from-[#001a4d]/90 via-[#0d0d0d]/75 to-[#0d0d0d]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_20%,rgba(158,126,67,0.2),transparent_50%)]" />

        <div className="relative z-10 mx-auto w-full max-w-6xl px-4 md:px-8 lg:px-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="flex max-w-2xl flex-col gap-3"
          >
            <p className="font-dm-sans text-xs font-semibold uppercase tracking-[0.22em] text-[#9e7e43]">
              Stay connected
            </p>
            <h1 className="font-outfit text-3xl font-semibold tracking-tight text-white md:text-5xl">
              News & Announcements
            </h1>
            <p className="font-dm-sans text-base leading-7 text-white/75 md:text-lg">
              Updates from across Dominion City Ireland.
            </p>
          </motion.div>
        </div>
      </section>

      <LandingNewsSection standalone />
      <LandingFooter />
    </div>
  )
}

export default NewsPage
